import { memo } from 'react';

import ReviewerIconSVG from '@/assets/reviewer-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

export type ReviewerIconProps = Omit<IconProps, 'SVGComponent'>;

const IReviewerIcon = ({ ...rest }: ReviewerIconProps) => {
  return <Icon SVGComponent={ReviewerIconSVG} {...rest} />;
};

export const ReviewerIcon = memo(IReviewerIcon) as typeof IReviewerIcon;
